"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author gevorg.avetisyan on 5/26/2017.
 */
var DataPointMetaMeService = /** @class */ (function () {
    function DataPointMetaMeService(id, name, type, systemName) {
        this._id = id;
        this._name = name;
        this._type = type;
        this._systemName = systemName;
    }
    Object.defineProperty(DataPointMetaMeService.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            this._id = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataPointMetaMeService.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (value) {
            this._name = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataPointMetaMeService.prototype, "type", {
        get: function () {
            return this._type;
        },
        set: function (value) {
            this._type = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataPointMetaMeService.prototype, "systemName", {
        get: function () {
            return this._systemName;
        },
        set: function (value) {
            this._systemName = value;
        },
        enumerable: true,
        configurable: true
    });
    return DataPointMetaMeService;
}());
exports.DataPointMetaMeService = DataPointMetaMeService;
//# sourceMappingURL=data-point-meta-me-service.model.js.map